<template>
<div class="goods">
    <div class="content">
        <div class="order-list">
            <div class="warmTips" v-if="orderList.content && !orderList.content.length">
              <img src="../../../assets/images/404.png"/>
              <span>没有找到相应内容哦</span>
            </div>
            <template v-for="item in orderList.content">
                <invoice-order
                        :item="item"
                        :key="item.title"
                        @d="d"
                ></invoice-order>
            </template>
        </div>
    </div>
    <div style="padding:0 20px; margin:20px 0">
        <van-button type="primary" block @click="next">下一步</van-button>
    </div>
</div>
</template>

<script>
import { Field, Button,Toast,CellGroup } from "vant";
import invoiceOrder from "../signUpMeeting/invoice.vue"
import {getOrderInfo,getUser,updateRegisterStep} from "@/api/dictionary";
export default {
  data() {
    return {
        const_invoice_status_no:1,
        const_invoice_status_apply:2,
        const_invoice_status_already:3,
        // const_order_status_paid:5,
        // const_order_status_paid:[4,5],
        title:"发票列表",
        loading: true,
        page: 1,
        filterBox: {
            invoiceStatus: 0
        },
        orderList: {
            content: []
        },
        userInfo:{}
    };
  },
  props: ["orderType"],
  filters: {
    
  },
  components: {
      invoiceOrder,
      [Button.name]: Button,
  },
  methods: {
      d(){
        this.getData();
      },
      getData: function() {
          this.loading = true;
          this.page=1;
          var params=this.filterBox;
        //   if(this.type==1){
        //       params.orderTypeList = [1,3,4,5,6];
        //   }else {
        //       params.orderStatusList = this.const_order_status_paid;
        //   }
          params.orderType = this.type;
          params.orderStatusList = this.const_order_status_paid;
          params.orderType = 2;
          params.mettingId = this.id;
          params.memberId = this.userInfo.id;
          params.access_token = sessionStorage.getItem("access_token");
          getOrderInfo(params, this.page - 1)
              .then(res => {
                  if (res.success) {
                      this.orderList = res.result;
                  }else{
                      Toast.fail(res.message);
                  }
              })
              .catch(() => {
                  Toast.fail("获取数据失败");
              })
              .finally(() => {
                  this.loading = false;
              });
      },
    next() {
      this.$emit("sendActive", 3);
          let params = {
                    memberId:this.userInfo.id,
                    meetingId:this.id,
                    registerStep:3
                }
              updateRegisterStep(params)
                .then(res =>{
                if(res.success){
                this.$emit("sendActive", 3);
                }else{
                    this.$tips.error("注册失败");
                }
                })
    },
    getUserInfo(){
      getUser().then(res=>{
        if (res.success) {
          this.userInfo = res.result;
          this.getData();
        }
        })
	  },
  },
  computed: {
      type(){
          return this.$route.query&&this.$route.query.type;
      },
      id() {
          return this.$route.query && this.$route.query.meetingId;
      }
    },
  watch:{
	
  },
  mounted() {
	  this.getData();
      this.getUserInfo();
  }

}
</script>
<style  lang="less" scoped>
    .Payment{
        position: absolute;
        z-index: 9999;
        right: 20px;
        top: 21px;
        color: #fff;
    }

    .Order{ background: #fafafa; padding:15px 0; margin-top: 15px; }
    .Order p{ line-height: 24px; color: #848484; }
    .fontsBox{
        width: 84%;
        margin:20px auto 0 auto;
        background: #fff6ec;
        padding:14px;
        font-size: 13px;
        border: #f6d0a2 dashed 1px;
        line-height: 22px;
        color: #ffbe4e;
    }
    .warmTips,.orderTip{     font-size: 16px;
        text-align: center;
        margin-top: 25%; }
</style>